// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/log-out.js';

import { paths } from '../generated/log-out';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('log-out', Original, paths);
